import React, { Component } from 'react';
import { Row, Col, Icon, Translate, Button, Input, Modal } from '$common';
import CSSModules from 'react-css-modules';
import { browserHistory } from 'react-router';
import { groupBy } from 'lodash';
import style from '../show/show.scss';
import { getDraft } from '$lib/draft-manager';

@CSSModules(style)
export default class Layout extends Component {

  state = {
    groupedProjects: {},
    currentRouteName: window.location.pathname.split('/') || []
  };

  componentWillMount() {
    const { projects, params, query } = this.props;

    if (projects.length > 0) {
      const groupedProjects = groupBy(projects, 'status');
      if (typeof params.id === "undefined" || params.id === "insights" || params.id === "submissions") {
        if (typeof groupedProjects.available === "object") {
          browserHistory.push(`/project/${groupedProjects.available[0].id}${query.path && '/'+query.path || ''}`)
        } else if (typeof groupedProjects.not_available === "object") {
          browserHistory.push(`/project/${groupedProjects.not_available[0].id}${query.path && '/'+query.path || ''}`)
        } else if(typeof groupedProjects.from_customer === "object") {
          browserHistory.push(`/project/${groupedProjects.from_customer[0].id}/edit`)
        }
      } else {
        this.props.onLoadAllData();
      }
      this.setState({ groupedProjects });
    }
  }

  componentWillReceiveProps() {
    this.setState({ currentRouteName: window.location.pathname.split('/') || [] });
  }

  redirect(id) {
    // window.Intercom('trackEvent', 'SELECTED_PROJECT');
    const currentRouteName = window.location.pathname.split('/');
    if (currentRouteName[currentRouteName.length - 1] === "submissions") {
      browserHistory.push(`/project/${id}/submissions`);
    } else if (currentRouteName[currentRouteName.length - 2] === "insights" || currentRouteName[currentRouteName.length - 1] === "insights") {
      browserHistory.push(`/project/${id}/insights`);
    } else {
      browserHistory.push(`/project/${id}`);
    }
  }

  async searchProject(value) {
    this.setState({ searchValue: value })
    await this.props.getProjects('customer_name_cont', value);
  }

  items() {
    const { projects } = this.props;
    const groupedProjects = groupBy(projects, 'status');

    return(
      [
        typeof projects === "object" ?
          <li styleName="list" key={0}>
            <ul>
              <li>
                <Input
                  placeholder={Translate.get('type_project_name')}
                  onChange={::this.searchProject}
                  value={this.state.searchValue || ''}
                  forceOnChange
                />
              </li>
              {
                typeof groupedProjects.available === "object" ?
                  <li styleName="separator">{Translate.get('ongoing_tasks')}</li>
                : ''
              }
              {
                typeof groupedProjects.available === "object" ?
                  groupedProjects.available.map( (item, index) => (
                    <li key={index}><a id="live-project-select-button" onClick={() => this.redirect(item.id)}>{item.name}</a></li>
                  ))
                : ''
              }

              {
                typeof groupedProjects.not_available === "object" ?
                  <li styleName="separator">{Translate.get('completed_tasks')}</li>
                : ''
              }
              {
                typeof groupedProjects.not_available === "object" ?
                  groupedProjects.not_available.map( (item, index) => (
                    <li key={index}><a id="live-project-select-button" onClick={() => this.redirect(item.id)}>{item.name}</a></li>
                  ))
                : ''
              }

              {
                typeof groupedProjects.from_customer === "object" ?
                  <li styleName="separator">{Translate.get('pending_approval')}</li>
                : ''
              }
              {
                typeof groupedProjects.from_customer === "object" ?
                  groupedProjects.from_customer.map( (item, index) => (
                    <li key={index}><a id="live-project-select-button" onClick={() => this.redirect(item.id)}>{item.name}</a></li>
                  ))
                : ''
              }
            </ul>
          </li>
        : ''
  
      ]
    )
  }

  createProject() {
    if (getDraft()) {
      this.setState({ isDraftModalOpen: true })
    } else {
      browserHistory.push('/project/create');
    }
  }

  render() {
    const { project, onDeleteProject, activityMap, submissions, currentPage, totalSubmissionsCount, onFilterChange, filters, createReport, insight } = this.props;
    const { isDraftModalOpen, currentRouteName } = this.state;

    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        project,
        activityMap,
        submissions,
        currentPage,
        totalSubmissionsCount,
        onFilterChange,
        filters,
        createReport,
        insight
      });
    });

    return (
      <div styleName="root">
        {
          typeof project === "object" && project !== null ? 
            <div styleName="projects" id="not-printable">
              <Row>
                <Col md="2/3" gutter={0}>
                  <ul styleName="list-wrapper">
                    <li styleName="current-project">
                      <span>{project.name}</span> <Icon name="angle-down" />
                    </li>
                    {this.items()}
                  </ul>
                </Col>
                {
                   !['insights', 'submissions'].includes(currentRouteName[currentRouteName.length - 1]) ?
                    <Col md="1/3" dir="ltr">
                      {
                        project.status === 'from_customer' ?
                          [
                            <Button key={1} type="weak" styleName="action" onClick={ () => { browserHistory.push(`/project/${project.id}/edit`); location.reload() }}><Icon name="pencil"/></Button>,
                            <Button key={2} type="danger" styleName="action" onClick={ () => confirm(Translate.get('are_you_sure')) ? onDeleteProject(project.id) : ''}><Icon name="trash"/></Button>
                          ]
                          : ''
                      }
                      {
                        process.twentify.indexOf(process.target[0]) !== -1 ?
                          <Button type="success" styleName="create-project" onClick={::this.createProject}>{Translate.get('create_task')} (Beta)</Button>
                        : ''
                      }
                    </Col>
                  : null
                }
              </Row>
            </div>
          : ''
        }

        <Modal
          isOpen={isDraftModalOpen}
          closeable={true}
          title={Translate.get("draft_modal_title")}
          size="small"
        >
          {Translate.get("draft_modal_message")}
          <br /><br />
          <Row>
            <Col md="1/2">
              <Button block type="success" onClick={() => browserHistory.push('/project/create?create_from_draft=true')}>{Translate.get("yes")}</Button>
            </Col>
            <Col md="1/2">
              <Button block type="ghost" onClick={() => browserHistory.push('/project/create')}>{Translate.get("no")}</Button>
            </Col>
          </Row>
        </Modal>

        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project/layout/layout.js